import jwt from 'jsonwebtoken'
export const activateProctor = (RPToken) => {

	/*if(!RPToken || RPToken === '') {
		alert("coming here")
		window.proctorStarted = false;
		localStorage.setItem('RPToken', '')
		window.location.reload()
	}*/

	window.remoteProctoring.remoteProctorInitV2({authToken: RPToken}).then(function () {
			// start proctoring session
			window.proctorStarted = true;
			console.log('proctor start');
			localStorage.setItem('RPStart', '1')
			//return window.supervisor.start();
		})
		.catch(function (err) {
			// show alert with an error
			console.log('proctor launch error', err);
			window.proctorStarted = false;
			localStorage.setItem('RPToken', '')
			window.location.reload()
		});
	return RPToken;
};

export const stopProctor = () => {
	if(window.proctorStarted) {
		window.proctorStarted = false;
		console.log('proctor 1 stop');
		window.remoteProctoring.stop();
	} else {
		window.remoteProctoring.stop();
	}
}; 

export const checkProctorStatus = () => {
	return window.proctorStarted
}